import { useItAvailabilityAlert } from '@/hooks/useItAvailabilityAlert';

/**
 * 「自分の空き待ちに空きが出た」瞬間をアプリ全体で監視するための、DOMを描画しない部品。
 * ログイン中のみ音＋バッジで知らせる（`useItAvailabilityAlert` を参照）。
 * `App` に1度だけマウントする。
 */
export default function ItAvailabilityAlert() {
  useItAvailabilityAlert();
  return null;
}